// extracted by mini-css-extract-plugin
export default {"button":"MenuButton_button__O0KbP","active":"MenuButton_active__V1MEG","redDot":"MenuButton_redDot__LlwMV"};